import(/* webpackMode: "eager" */ "/vercel/path0/packages/vite-app-ts/src/app/[locale]/(home)/layout.tsx");
